"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3672],{

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86594);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31955);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63372);
// components/AddressAutocomplete.js







const AddressAutocomplete = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [selectedAddress, setSelectedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [getLocationLoading, setgetLocationLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, seterror] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleSelect = (address)=>{
        setSelectedAddress(address);
        // Retrieve additional details including pincode
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            placeId: address.value.place_id
        }, async (results, status)=>{
            if (status === "OK" && results[0]) {
                const pincode = extractPincodeFromResults(results[0]);
                if (!pincode && results[0].place_id) {
                    let pinnn = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://proxy.orientbell.com/getpininfobyplaceid?pin=".concat(results[0].place_id));
                    const { lat , lng  } = pinnn.data.pplaceInfo.result.geometry.location;
                    const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(lat, "&lon=").concat(lng, "&format=json"));
                    const address = response.data.address;
                    if (address && address.postcode) {
                        const pincode1 = address.postcode;
                        props.setLocationPopop(false);
                        props.setleadpopop();
                        setTimeout(()=>{
                            props.settarrekImage(true);
                        }, 3000);
                        localStorage.setItem("pincodeSkip", true);
                        js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode1, {
                            expires: 7,
                            secure: true,
                            sameSite: "Strict"
                        });
                        (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                            pincodedetails: pincode1
                        });
                        setgetLocationLoading(false);
                        if (router.asPath.includes("/tiles")) {
                            router.reload();
                        }
                    }
                    return;
                }
                // onSelect({ ...address, pincode });
                localStorage.setItem("pincodeSkip", true, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode);
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                props.setLocationPopop(false);
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            } else {
                console.log("Error fetching geocode data:", status);
            }
        });
    };
    const handlePincodeFetch = async ()=>{
        setgetLocationLoading(true);
        try {
            if ("geolocation" in navigator) {
                const permission = await navigator.permissions.query({
                    name: "geolocation"
                });
                if (permission.state === "granted") {
                    if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("pincode")) {
                        await retrieveGeolocation();
                    }
                } else if (permission.state === "prompt") {
                    navigator.geolocation.getCurrentPosition(async (position)=>{
                        if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("pincode")) {
                            await retrieveGeolocation();
                        }
                    }, (error)=>{
                        setgetLocationLoading(false);
                        seterror("Please enter your address / pin code for more accurate Information.");
                        console.log("Error retrieving location:", error);
                    // Handle error if needed
                    });
                } else {
                    // Permission denied or unavailable
                    setgetLocationLoading(false);
                    seterror("Please enter your address / pin code for more accurate Information.");
                    console.log("Geolocation permission denied or unavailable.");
                // Handle denied permission or unavailable state
                }
            } else {
                setgetLocationLoading(false);
                seterror("Geolocation is not supported by this browser.");
                console.log("Geolocation is not supported by this browser.");
            // Handle unsupported geolocation
            }
        } catch (error) {
            setgetLocationLoading(false);
            seterror("Error checking geolocation permission:");
            console.log("Error checking geolocation permission:", error);
        // Handle error if needed
        }
    };
    const retrieveGeolocation = async ()=>{
        try {
            const position = await new Promise((resolve, reject)=>{
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                });
            });
            if (!router.asPath.includes("/tiles")) {
                props.setLocationPopop(false);
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                setgetLocationLoading(false);
            }
            const { latitude , longitude  } = position.coords;
            const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://nominatim.openstreetmap.org/reverse?lat=".concat(latitude, "&lon=").concat(longitude, "&format=json"));
            const address = response.data.address;
            if (address && address.postcode) {
                const pincode = address.postcode;
                props.setLocationPopop(false);
                props.setleadpopop();
                setTimeout(()=>{
                    props.settarrekImage(true);
                }, 3000);
                localStorage.setItem("pincodeSkip", true);
                js_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"].set */ .Z.set("pincode", pincode, {
                    expires: 7,
                    secure: true,
                    sameSite: "Strict"
                });
                (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_5__/* .savePincode */ .y1)({
                    pincodedetails: pincode
                });
                setgetLocationLoading(false);
                if (router.asPath.includes("/tiles")) {
                    router.reload();
                }
            }
        } catch (error) {
            console.log("Error retrieving location:", error);
            const errorMessage = error.message || "Something went wrong while retrieving your location.";
            swal(errorMessage);
        }
    };
    const extractPincodeFromResults = (result)=>{
        const postalCodeComponent = result.address_components.find((component)=>component.types.includes("postal_code"));
        return postalCodeComponent ? postalCodeComponent.short_name : "";
    };
    const renderSuggestions = (active, suggestions, onSelectSuggestion)=>{
        const filteredSuggestions = suggestions.filter((suggestion)=>{
            const hasPostalCode = suggestion.terms.some((term)=>term.types.includes("postal_code"));
            return hasPostalCode;
        });
        return filteredSuggestions.map((suggestion)=>{
            const isActive = active === suggestion.active;
            const classNames = "suggestion-item ".concat(isActive ? "active" : "");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classNames,
                onClick: ()=>onSelectSuggestion(suggestion),
                children: suggestion.description
            }, suggestion.placeId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: getLocationLoading ? "btn btn-secondary" : "btn btn-success",
                disabled: getLocationLoading,
                onClick: ()=>{
                    handlePincodeFetch();
                },
                children: getLocationLoading ? "Fetching" : "Detect Location"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                class: "location-or-bx",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "OR"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_places_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                apiKey: "AIzaSyBrmlHMs5JUON_ErXHEKk_HSd2UoLN20HQ",
                autocompletionRequest: {
                    componentRestrictions: {
                        country: [
                            "in"
                        ]
                    }
                },
                selectProps: {
                    value: selectedAddress,
                    onChange: handleSelect,
                    placeholder: "Search for your address"
                },
                renderSuggestions: renderSuggestions
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "error text-danger",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressAutocomplete);


/***/ }),

/***/ 4260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35005);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83346);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63372);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4492);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89583);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81288);
/* harmony import */ var react_country_flag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99318);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6212);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31955);
/* harmony import */ var _address__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1134);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6154);
















const Footer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const [TimePopup, setTimePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [getInTouch, setGetInTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isActive, setIsActive] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [tarrekImage, settarrekImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [LocationPopop, setLocationPopop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [timeOutIDS, settimeOutIDS] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isClassToggled, setIsClassToggled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Array(15).fill(false));
    const toggleClass = (index)=>{
        const updatedStates = [
            ...isClassToggled
        ];
        updatedStates[index] = !updatedStates[index];
        setIsClassToggled(updatedStates);
    };
    const [callBackDto, setCallBackDto] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false,
        countryCode: "",
        email: "",
        cc: ""
    });
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("pincode"),
        countryCode: "",
        error: "",
        loading: false,
        cc: "",
        email: ""
    });
    const [recording, setRecording] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [audioBlob, setAudioBlob] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [recordedText, setrecordedText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const mediaRecorderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const audioChunksRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const startRecording = async ()=>{
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        mediaRecorderRef.current = new MediaRecorder(stream);
        mediaRecorderRef.current.ondataavailable = (event)=>{
            audioChunksRef.current.push(event.data);
        };
        mediaRecorderRef.current.onstop = ()=>{
            const audioBlob = new Blob(audioChunksRef.current, {
                type: "audio/wav"
            });
            setAudioBlob(audioBlob);
            audioChunksRef.current = [];
        };
        mediaRecorderRef.current.start();
        setRecording(true);
        const recognition = new window.webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = false;
        recognition.lang = "en-US"; // Set language as needed
        recognition.onresult = (event)=>{
            const currentTranscript = event.results[event.results.length - 1][0].transcript;
            setrecordedText(currentTranscript);
        };
        recognition.onerror = (event)=>{
            console.log("Speech recognition error detected: " + event.error);
        };
        recognition.onend = ()=>{
            console.log("Speech recognition ended.");
        };
        recognition.start();
    };
    const stopRecording = ()=>{
        mediaRecorderRef.current.stop();
        setRecording(false);
    };
    const uploadAudio = async (LeadID)=>{
        const formData = new FormData();
        formData.append("audio", audioBlob, "recording.wav");
        formData.append("LeadID", LeadID);
        formData.append("Audio_Text", recordedText);
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].post */ .Z.post("https://obl-js.orientbell.com/uploadAudio", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
        } catch (error) {
            console.log("Upload error");
        }
    };
    const countries = [
        {
            name: "Afghanistan",
            code: "93",
            cc: "AF"
        },
        {
            name: "Albania",
            code: "355",
            cc: "AL"
        },
        {
            name: "Algeria",
            code: "213",
            cc: "DZ"
        },
        {
            name: "American Samoa",
            code: "1-684",
            cc: "AS"
        },
        {
            name: "Andorra",
            code: "376",
            cc: "AD"
        },
        {
            name: "Angola",
            code: "244",
            cc: "AO"
        },
        {
            name: "Anguilla",
            code: "1-264",
            cc: "AI"
        },
        {
            name: "Antarctica",
            code: "672",
            cc: "AQ"
        },
        {
            name: "Antigua and Barbuda",
            code: "1-268",
            cc: "AG"
        },
        {
            name: "Argentina",
            code: "54",
            cc: "AR"
        },
        {
            name: "Armenia",
            code: "374",
            cc: "AM"
        },
        {
            name: "Aruba",
            code: "297",
            cc: "AW"
        },
        {
            name: "Australia",
            code: "61",
            cc: "AU"
        },
        {
            name: "Austria",
            code: "43",
            cc: "AT"
        },
        {
            name: "Azerbaijan",
            code: "994",
            cc: "AZ"
        },
        {
            name: "Bahamas",
            code: "1-242",
            cc: "BS"
        },
        {
            name: "Bahrain",
            code: "973",
            cc: "BH"
        },
        {
            name: "Bangladesh",
            code: "880",
            cc: "BD"
        },
        {
            name: "Barbados",
            code: "1-246",
            cc: "BB"
        },
        {
            name: "Belarus",
            code: "375",
            cc: "BY"
        },
        {
            name: "Belgium",
            code: "32",
            cc: "BE"
        },
        {
            name: "Belize",
            code: "501",
            cc: "BZ"
        },
        {
            name: "Benin",
            code: "229",
            cc: "BJ"
        },
        {
            name: "Bermuda",
            code: "1-441",
            cc: "BM"
        },
        {
            name: "Bhutan",
            code: "975",
            cc: "BT"
        },
        {
            name: "Bolivia",
            code: "591",
            cc: "BO"
        },
        {
            name: "Bosnia and Herzegovina",
            code: "387",
            cc: "BA"
        },
        {
            name: "Botswana",
            code: "267",
            cc: "BW"
        },
        {
            name: "Brazil",
            code: "55",
            cc: "BR"
        },
        {
            name: "British Indian Ocean Territory",
            code: "246",
            cc: "IO"
        },
        {
            name: "British Virgin Islands",
            code: "1-284",
            cc: "VG"
        },
        {
            name: "Brunei",
            code: "673",
            cc: "BN"
        },
        {
            name: "Bulgaria",
            code: "359",
            cc: "BG"
        },
        {
            name: "Burkina Faso",
            code: "226",
            cc: "BF"
        },
        {
            name: "Burundi",
            code: "257",
            cc: "BI"
        },
        {
            name: "Cambodia",
            code: "855",
            cc: "KH"
        },
        {
            name: "Cameroon",
            code: "237",
            cc: "CM"
        },
        {
            name: "Canada",
            code: "1",
            cc: "CA"
        },
        {
            name: "Cape Verde",
            code: "238",
            cc: "CV"
        },
        {
            name: "Cayman Islands",
            code: "1-345",
            cc: "KY"
        },
        {
            name: "Central African Republic",
            code: "236",
            cc: "CF"
        },
        {
            name: "Chad",
            code: "235",
            cc: "TD"
        },
        {
            name: "Chile",
            code: "56",
            cc: "CL"
        },
        {
            name: "China",
            code: "86",
            cc: "CN"
        },
        {
            name: "Christmas Island",
            code: "61",
            cc: "CX"
        },
        {
            name: "Cocos Islands",
            code: "61",
            cc: "CC"
        },
        {
            name: "Colombia",
            code: "57",
            cc: "CO"
        },
        {
            name: "Comoros",
            code: "269",
            cc: "KM"
        },
        {
            name: "Cook Islands",
            code: "682",
            cc: "CK"
        },
        {
            name: "Costa Rica",
            code: "506",
            cc: "CR"
        },
        {
            name: "Croatia",
            code: "385",
            cc: "HR"
        },
        {
            name: "Cuba",
            code: "53",
            cc: "CU"
        },
        {
            name: "Curacao",
            code: "599",
            cc: "CW"
        },
        {
            name: "Cyprus",
            code: "357",
            cc: "CY"
        },
        {
            name: "Czech Republic",
            code: "420",
            cc: "CZ"
        },
        {
            name: "Democratic Republic of the Congo",
            code: "243",
            cc: "CD"
        },
        {
            name: "Denmark",
            code: "45",
            cc: "DK"
        },
        {
            name: "Djibouti",
            code: "253",
            cc: "DJ"
        },
        {
            name: "Dominica",
            code: "1-767",
            cc: "DM"
        },
        {
            name: "Dominican Republic",
            code: "1-809, 1-829, 1-849",
            cc: "DO"
        },
        {
            name: "East Timor",
            code: "670",
            cc: "TL"
        },
        {
            name: "Ecuador",
            code: "593",
            cc: "EC"
        },
        {
            name: "Egypt",
            code: "20",
            cc: "EG"
        },
        {
            name: "El Salvador",
            code: "503",
            cc: "SV"
        },
        {
            name: "Equatorial Guinea",
            code: "240",
            cc: "GQ"
        },
        {
            name: "Eritrea",
            code: "291",
            cc: "ER"
        },
        {
            name: "Estonia",
            code: "372",
            cc: "EE"
        },
        {
            name: "Ethiopia",
            code: "251",
            cc: "ET"
        },
        {
            name: "Falkland Islands",
            code: "500",
            cc: "FK"
        },
        {
            name: "Faroe Islands",
            code: "298",
            cc: "FO"
        },
        {
            name: "Fiji",
            code: "679",
            cc: "FJ"
        },
        {
            name: "Finland",
            code: "358",
            cc: "FI"
        },
        {
            name: "France",
            code: "33",
            cc: "FR"
        },
        {
            name: "French Polynesia",
            code: "689",
            cc: "PF"
        },
        {
            name: "Gabon",
            code: "241",
            cc: "GA"
        },
        {
            name: "Gambia",
            code: "220",
            cc: "GM"
        },
        {
            name: "Georgia",
            code: "995",
            cc: "GE"
        },
        {
            name: "Germany",
            code: "49",
            cc: "DE"
        },
        {
            name: "Ghana",
            code: "233",
            cc: "GH"
        },
        {
            name: "Gibraltar",
            code: "350",
            cc: "GI"
        },
        {
            name: "Greece",
            code: "30",
            cc: "GR"
        },
        {
            name: "Greenland",
            code: "299",
            cc: "GL"
        },
        {
            name: "Grenada",
            code: "1-473",
            cc: "GD"
        },
        {
            name: "Guam",
            code: "1-671",
            cc: "GU"
        },
        {
            name: "Guatemala",
            code: "502",
            cc: "GT"
        },
        {
            name: "Guernsey",
            code: "44-1481",
            cc: "GG"
        },
        {
            name: "Guinea",
            code: "224",
            cc: "GN"
        },
        {
            name: "Guinea-Bissau",
            code: "245",
            cc: "GW"
        },
        {
            name: "Guyana",
            code: "592",
            cc: "GY"
        },
        {
            name: "Haiti",
            code: "509",
            cc: "HT"
        },
        {
            name: "Honduras",
            code: "504",
            cc: "HN"
        },
        {
            name: "Hong Kong",
            code: "852",
            cc: "HK"
        },
        {
            name: "Hungary",
            code: "36",
            cc: "HU"
        },
        {
            name: "Iceland",
            code: "354",
            cc: "IS"
        },
        {
            name: "India",
            code: "91",
            cc: "IN"
        },
        {
            name: "Indonesia",
            code: "62",
            cc: "ID"
        },
        {
            name: "Iran",
            code: "98",
            cc: "IR"
        },
        {
            name: "Iraq",
            code: "964",
            cc: "IQ"
        },
        {
            name: "Ireland",
            code: "353",
            cc: "IE"
        },
        {
            name: "Isle of Man",
            code: "44-1624",
            cc: "IM"
        },
        {
            name: "Israel",
            code: "972",
            cc: "IL"
        },
        {
            name: "Italy",
            code: "39",
            cc: "IT"
        },
        {
            name: "Ivory Coast",
            code: "225",
            cc: "CI"
        },
        {
            name: "Jamaica",
            code: "1-876",
            cc: "JM"
        },
        {
            name: "Japan",
            code: "81",
            cc: "JP"
        },
        {
            name: "Jersey",
            code: "44-1534",
            cc: "JE"
        },
        {
            name: "Jordan",
            code: "962",
            cc: "JO"
        },
        {
            name: "Kazakhstan",
            code: "7",
            cc: "KZ"
        },
        {
            name: "Kenya",
            code: "254",
            cc: "KE"
        },
        {
            name: "Kiribati",
            code: "686",
            cc: "KI"
        },
        {
            name: "Kosovo",
            code: "383",
            cc: "XK"
        },
        {
            name: "Kuwait",
            code: "965",
            cc: "KW"
        },
        {
            name: "Kyrgyzstan",
            code: "996",
            cc: "KG"
        },
        {
            name: "Laos",
            code: "856",
            cc: "LA"
        },
        {
            name: "Latvia",
            code: "371",
            cc: "LV"
        },
        {
            name: "Lebanon",
            code: "961",
            cc: "LB"
        },
        {
            name: "Lesotho",
            code: "266",
            cc: "LS"
        },
        {
            name: "Liberia",
            code: "231",
            cc: "LR"
        },
        {
            name: "Libya",
            code: "218",
            cc: "LY"
        },
        {
            name: "Liechtenstein",
            code: "423",
            cc: "LI"
        },
        {
            name: "Lithuania",
            code: "370",
            cc: "LT"
        },
        {
            name: "Luxembourg",
            code: "352",
            cc: "LU"
        },
        {
            name: "Macau",
            code: "853",
            cc: "MO"
        },
        {
            name: "Macedonia",
            code: "389",
            cc: "MK"
        },
        {
            name: "Madagascar",
            code: "261",
            cc: "MG"
        },
        {
            name: "Malawi",
            code: "265",
            cc: "MW"
        },
        {
            name: "Malaysia",
            code: "60",
            cc: "MY"
        },
        {
            name: "Maldives",
            code: "960",
            cc: "MV"
        },
        {
            name: "Mali",
            code: "223",
            cc: "ML"
        },
        {
            name: "Malta",
            code: "356",
            cc: "MT"
        },
        {
            name: "Marshall Islands",
            code: "692",
            cc: "MH"
        },
        {
            name: "Mauritania",
            code: "222",
            cc: "MR"
        },
        {
            name: "Mauritius",
            code: "230",
            cc: "MU"
        },
        {
            name: "Mayotte",
            code: "262",
            cc: "YT"
        },
        {
            name: "Mexico",
            code: "52",
            cc: "MX"
        },
        {
            name: "Micronesia",
            code: "691",
            cc: "FM"
        },
        {
            name: "Moldova",
            code: "373",
            cc: "MD"
        },
        {
            name: "Monaco",
            code: "377",
            cc: "MC"
        },
        {
            name: "Mongolia",
            code: "976",
            cc: "MN"
        },
        {
            name: "Montenegro",
            code: "382",
            cc: "ME"
        },
        {
            name: "Montserrat",
            code: "1-664",
            cc: "MS"
        },
        {
            name: "Morocco",
            code: "212",
            cc: "MA"
        },
        {
            name: "Mozambique",
            code: "258",
            cc: "MZ"
        },
        {
            name: "Myanmar",
            code: "95",
            cc: "MM"
        },
        {
            name: "Namibia",
            code: "264",
            cc: "NA"
        },
        {
            name: "Nauru",
            code: "674",
            cc: "NR"
        },
        {
            name: "Nepal",
            code: "977",
            cc: "NP"
        },
        {
            name: "Netherlands",
            code: "31",
            cc: "NL"
        },
        {
            name: "Netherlands Antilles",
            code: "599",
            cc: "AN"
        },
        {
            name: "New Caledonia",
            code: "687",
            cc: "NC"
        },
        {
            name: "New Zealand",
            code: "64",
            cc: "NZ"
        },
        {
            name: "Nicaragua",
            code: "505",
            cc: "NI"
        },
        {
            name: "Niger",
            code: "227",
            cc: "NE"
        },
        {
            name: "Nigeria",
            code: "234",
            cc: "NG"
        },
        {
            name: "Niue",
            code: "683",
            cc: "NU"
        },
        {
            name: "North Korea",
            code: "850",
            cc: "KP"
        },
        {
            name: "Northern Mariana Islands",
            code: "1-670",
            cc: "MP"
        },
        {
            name: "Norway",
            code: "47",
            cc: "NO"
        },
        {
            name: "Oman",
            code: "968",
            cc: "OM"
        },
        {
            name: "Pakistan",
            code: "92",
            cc: "PK"
        },
        {
            name: "Palau",
            code: "680",
            cc: "PW"
        },
        {
            name: "Palestine",
            code: "970",
            cc: "PS"
        },
        {
            name: "Panama",
            code: "507",
            cc: "PA"
        },
        {
            name: "Papua New Guinea",
            code: "675",
            cc: "PG"
        },
        {
            name: "Paraguay",
            code: "595",
            cc: "PY"
        },
        {
            name: "Peru",
            code: "51",
            cc: "PE"
        },
        {
            name: "Philippines",
            code: "63",
            cc: "PH"
        },
        {
            name: "Pitcairn",
            code: "64",
            cc: "PN"
        },
        {
            name: "Poland",
            code: "48",
            cc: "PL"
        },
        {
            name: "Portugal",
            code: "351",
            cc: "PT"
        },
        {
            name: "Puerto Rico",
            code: "1-787, 1-939",
            cc: "PR"
        },
        {
            name: "Qatar",
            code: "974",
            cc: "QA"
        },
        {
            name: "Republic of the Congo",
            code: "242",
            cc: "CG"
        },
        {
            name: "Reunion",
            code: "262",
            cc: "RE"
        },
        {
            name: "Romania",
            code: "40",
            cc: "RO"
        },
        {
            name: "Russia",
            code: "7",
            cc: "RU"
        },
        {
            name: "Rwanda",
            code: "250",
            cc: "RW"
        },
        {
            name: "Saint Barthelemy",
            code: "590",
            cc: "BL"
        },
        {
            name: "Saint Helena",
            code: "290",
            cc: "SH"
        },
        {
            name: "Saint Kitts and Nevis",
            code: "1-869",
            cc: "KN"
        },
        {
            name: "Saint Lucia",
            code: "1-758",
            cc: "LC"
        },
        {
            name: "Saint Martin",
            code: "590",
            cc: "MF"
        },
        {
            name: "Saint Pierre and Miquelon",
            code: "508",
            cc: "PM"
        },
        {
            name: "Saint Vincent and the Grenadines",
            code: "1-784",
            cc: "VC"
        },
        {
            name: "Samoa",
            code: "685",
            cc: "WS"
        },
        {
            name: "San Marino",
            code: "378",
            cc: "SM"
        },
        {
            name: "Sao Tome and Principe",
            code: "239",
            cc: "ST"
        },
        {
            name: "Saudi Arabia",
            code: "966",
            cc: "SA"
        },
        {
            name: "Senegal",
            code: "221",
            cc: "SN"
        },
        {
            name: "Serbia",
            code: "381",
            cc: "RS"
        },
        {
            name: "Seychelles",
            code: "248",
            cc: "SC"
        },
        {
            name: "Sierra Leone",
            code: "232",
            cc: "SL"
        },
        {
            name: "Singapore",
            code: "65",
            cc: "SG"
        },
        {
            name: "Sint Maarten",
            code: "1-721",
            cc: "SX"
        },
        {
            name: "Slovakia",
            code: "421",
            cc: "SK"
        },
        {
            name: "Slovenia",
            code: "386",
            cc: "SI"
        },
        {
            name: "Solomon Islands",
            code: "677",
            cc: "SB"
        },
        {
            name: "Somalia",
            code: "252",
            cc: "SO"
        },
        {
            name: "South Africa",
            code: "27",
            cc: "ZA"
        },
        {
            name: "South Korea",
            code: "82",
            cc: "KR"
        },
        {
            name: "South Sudan",
            code: "211",
            cc: "SS"
        },
        {
            name: "Spain",
            code: "34",
            cc: "ES"
        },
        {
            name: "Sri Lanka",
            code: "94",
            cc: "LK"
        },
        {
            name: "Sudan",
            code: "249",
            cc: "SD"
        },
        {
            name: "Suriname",
            code: "597",
            cc: "SR"
        },
        {
            name: "Svalbard and Jan Mayen",
            code: "47",
            cc: "SJ"
        },
        {
            name: "Swaziland",
            code: "268",
            cc: "SZ"
        },
        {
            name: "Sweden",
            code: "46",
            cc: "SE"
        },
        {
            name: "Switzerland",
            code: "41",
            cc: "CH"
        },
        {
            name: "Syria",
            code: "963",
            cc: "SY"
        },
        {
            name: "Taiwan",
            code: "886",
            cc: "TW"
        },
        {
            name: "Tajikistan",
            code: "992",
            cc: "TJ"
        },
        {
            name: "Tanzania",
            code: "255",
            cc: "TZ"
        },
        {
            name: "Thailand",
            code: "66",
            cc: "TH"
        },
        {
            name: "Togo",
            code: "228",
            cc: "TG"
        },
        {
            name: "Tokelau",
            code: "690",
            cc: "TK"
        },
        {
            name: "Tonga",
            code: "676",
            cc: "TO"
        },
        {
            name: "Trinidad and Tobago",
            code: "1-868",
            cc: "TT"
        },
        {
            name: "Tunisia",
            code: "216",
            cc: "TN"
        },
        {
            name: "Turkey",
            code: "90",
            cc: "TR"
        },
        {
            name: "Turkmenistan",
            code: "993",
            cc: "TM"
        },
        {
            name: "Turks and Caicos Islands",
            code: "1-649",
            cc: "TC"
        },
        {
            name: "Tuvalu",
            code: "688",
            cc: "TV"
        },
        {
            name: "U.S. Virgin Islands",
            code: "1-340",
            cc: "VI"
        },
        {
            name: "Uganda",
            code: "256",
            cc: "UG"
        },
        {
            name: "Ukraine",
            code: "380",
            cc: "UA"
        },
        {
            name: "United Arab Emirates",
            code: "971",
            cc: "AE"
        },
        {
            name: "United Kingdom",
            code: "44",
            cc: "GB"
        },
        {
            name: "United States",
            code: "1",
            cc: "US"
        },
        {
            name: "Uruguay",
            code: "598",
            cc: "UY"
        },
        {
            name: "Uzbekistan",
            code: "998",
            cc: "UZ"
        },
        {
            name: "Vanuatu",
            code: "678",
            cc: "VU"
        },
        {
            name: "Vatican",
            code: "379",
            cc: "VA"
        },
        {
            name: "Venezuela",
            code: "58",
            cc: "VE"
        },
        {
            name: "Vietnam",
            code: "84",
            cc: "VN"
        },
        {
            name: "Wallis and Futuna",
            code: "681",
            cc: "WF"
        },
        {
            name: "Western Sahara",
            code: "212",
            cc: "EH"
        },
        {
            name: "Yemen",
            code: "967",
            cc: "YE"
        },
        {
            name: "Zambia",
            code: "260",
            cc: "ZM"
        },
        {
            name: "Zimbabwe",
            code: "263",
            cc: "ZW"
        }
    ];
    const handleClick = ()=>{
        setIsActive(!isActive);
        timeOutIDS.forEach((id)=>clearTimeout(id));
    };
    const onValueChange = (e, title)=>{
        setCallBackDto({
            ...callBackDto,
            [title]: e.target.value
        });
    };
    // const onSubmitClick  = () => {
    // 	const namee = callBackDto.name;
    // 	const no = callBackDto.number;
    // 	var myHeaders = new Headers();
    // 	myHeaders.append("Content-Type", "application/json");
    // 	myHeaders.append("Cookie", "1a99390653=fa937bf8820a337da6a65156d344d3c2; _zcsr_tmp=8c6b538d-4aaf-45da-a252-ed2ea34ed593; crmcsr=8c6b538d-4aaf-45da-a252-ed2ea34ed593");
    // 	var raw = JSON.stringify({
    // 		"Name": { namee },
    // 		"Phone": { no }
    // 	});
    // 	var requestOptions = {
    // 		method: 'POST',
    // 		headers: myHeaders,
    // 		body: raw,
    // 		redirect: 'follow'
    // 	};
    // 	fetch("https://www.zohoapis.com/crm/v2/functions/createrequestcallbackrecord/actions/execute?auth_type=apikey&zapikey=1003.4c1b2b4d3ee5141ee902ac79c05a933c.a83a093eaa7c599a881b3991bf5c5e7b", requestOptions)
    // 		.then(response => response.text())
    // 		.then(result => console.log(result))
    // 		.catch(error => console.log('error', error));
    // }
    const onSubmitClick = async ()=>{
        const namee = callBackDto.name;
        const no = callBackDto.number;
        const email = callBackDto.email;
        const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!router.asPath.includes("/exports-project") && !router.asPath.includes("/download-export-catalogue") && (!namee || !no) || (router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue")) && (!namee || !no || !email)) {
            setCallBackDto({
                ...callBackDto,
                error: "All Fields are required"
            });
        } else if (callBackDto.pincode && !router.asPath.includes("exports-project") && !router.asPath.includes("/download-export-catalogue") && !callBackDto.pincode.length == 6) {
            setCallBackDto({
                ...callBackDto,
                error: "Invalid Pincode"
            });
        } else if ((router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue")) && email && !emailFormat.test(email)) {
            setCallBackDto({
                ...callBackDto,
                error: "Invalid Email format"
            });
        } else {
            setCallBackDto({
                ...callBackDto,
                error: "",
                loading: true
            });
            //gtagConversionEvent()
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_3__/* .requestCallback */ .mq)({
                name: namee,
                phone: "".concat(callBackDto.countryCode).concat(no),
                pincode: callBackDto.pincode,
                email: email
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                sweetalert__WEBPACK_IMPORTED_MODULE_4___default()(response === null || response === void 0 ? void 0 : response.message);
                setCallBackDto({
                    ...callBackDto,
                    error: "",
                    loading: false
                });
            } else {
                sweetalert__WEBPACK_IMPORTED_MODULE_4___default()(response.data.request_callback.msg);
                setCallBackDto({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
            }
        }
    };
    const submitGetInTouch = async (subsource)=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        const email = touch.email;
        const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        //   console.log("PIN", pin)
        if (!router.asPath.includes("/exports-project") && !router.asPath.includes("/download-export-catalogue") && (!namee || !no) || (router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue")) && (!namee || !no || !email)) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (pin && !router.asPath.includes("/exports-project") && !router.asPath.includes("/download-export-catalogue") && String(pin).length !== 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else if (String(no).length > 13 || String(no).length < 9) {
            setTouch({
                ...touch,
                error: "Invalid Phone number"
            });
        } else if ((router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue")) && email && !emailFormat.test(email)) {
            setTouch({
                ...touch,
                error: "Invalid Email format"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            //   //gtagConversionEvent();
            try {
                let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_3__/* .getIntouch */ .JJ)({
                    name: namee,
                    phone: no,
                    pincode: pin,
                    email: email,
                    call_id: subsource
                });
                if (response === null || response === void 0 ? void 0 : response.message) {
                    localStorage.setItem("leadfilled", true);
                    sweetalert__WEBPACK_IMPORTED_MODULE_4___default()(response === null || response === void 0 ? void 0 : response.message);
                } else {
                    if (response.data.get_in_touch.lead_id) {
                        uploadAudio(response.data.get_in_touch.lead_id);
                    }
                    sweetalert__WEBPACK_IMPORTED_MODULE_4___default()(response.data.get_in_touch.msg);
                    handleClick();
                    setGetInTouch(false);
                    settarrekImage(false);
                    localStorage.setItem("TarikClosed", true);
                    setTouch({
                        name: "",
                        number: "",
                        pincode: "",
                        error: "",
                        loading: false,
                        email: ""
                    });
                }
            } catch (error) {
                console.log("Error submitting form:", error);
                setTouch({
                    ...touch,
                    error: "Error submitting form",
                    loading: false
                });
            }
        }
    };
    let setleadpopop = ()=>{
        const startTimeString = localStorage.getItem("startTime");
        let startTime = startTimeString && new Date(startTimeString).toLocaleDateString() == new Date().toLocaleDateString() ? new Date(startTimeString) : new Date();
        const elapsedTime = new Date() - startTime;
        //  if (elapsedTime < 15000) {
        // 	setTimeout(() => {
        // 		if(!localStorage.getItem('leadSkiped')){
        // 			setTimePopup(true);
        // 			setGetInTouch(true);
        // 		}
        // 	}, 15000 - elapsedTime);
        // } else if (elapsedTime < 60000) {
        // 	setTimeout(() => {
        // 		if(!localStorage.getItem('leadSkiped')){
        // 			setTimePopup(true);
        // 			setGetInTouch(true);
        // 		}
        // 	}, 60000 - elapsedTime);
        // } else if (elapsedTime < 120000) {
        // 	setTimeout(() => {
        // 		if(!localStorage.getItem('leadSkiped')){
        // 			setTimePopup(true);
        // 			setGetInTouch(true);}
        // 		}, 120000 - elapsedTime);
        // 	} else if (elapsedTime < 300000) {
        // 		setTimeout(() => {
        // 			if(!localStorage.getItem('leadSkiped')){
        // 				setTimePopup(true);
        // 				setGetInTouch(true);
        // 			}
        // 		}, 300000 - elapsedTime);
        // 	}
        let arrr = [];
        if (elapsedTime < 45000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 45000 - elapsedTime));
        } else if (elapsedTime < 60000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 60000 - elapsedTime));
        } else if (elapsedTime < 120000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 120000 - elapsedTime));
        } else if (elapsedTime < 300000 && !(props === null || props === void 0 ? void 0 : props.catalougePage)) {
            arrr.push(setTimeout(()=>{
                if (!localStorage.getItem("leadfilled")) {
                    setTimePopup(true);
                    setGetInTouch(true);
                }
            }, 300000 - elapsedTime));
        }
        settimeOutIDS(arrr);
        localStorage.setItem("startTime", startTime.toString());
    };
    const popoptarek = ()=>{
        if (document.referrer) {
            const referrerURL = new URL(document.referrer);
            if (referrerURL.hostname === window.location.hostname) {} else {
                setTimeout(()=>{
                    settarrekImage(true);
                }, 3000);
            }
        } else {
            setTimeout(()=>{
                settarrekImage(true);
            }, 3000);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!js_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("skipLocation") && !js_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("pincode") && (props === null || props === void 0 ? void 0 : props.displayLocationPopop)) {
            setLocationPopop(true);
        } else {
            setleadpopop();
            popoptarek();
        }
        const handleScroll = ()=>{
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;
            // Check if the scroll position is greater than or equal to 1000px
            if (scrollPosition >= 1000 && !localStorage.getItem("schrollSkip")) {
                setIsActive(true);
            }
        };
        // Attach the event listener when the component mounts
        // window.addEventListener('scroll', handleScroll);
        // Clean up the event listener when the component unmounts
        return ()=>{
        // clearTimeout(alertAfter15Sec);
        // clearTimeout(alertAfter1Min);
        // clearTimeout(alertAfter2Min);
        // clearTimeout(alertAfter5Min)
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: isActive ? "right_sidebar_form active" : "right_sidebar_form",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            submitGetInTouch("Get In Touch");
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "close-form",
                                onClick: handleClick,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaAngleRight */ .H_v, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                className: "mb-3",
                                controlId: "formBasicEmail",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                    type: "text",
                                    value: touch.name,
                                    placeholder: "Name*",
                                    onChange: (e)=>{
                                        setTouch({
                                            ...touch,
                                            name: e.target.value
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                className: "mb-3",
                                controlId: "formBasicPassword",
                                children: router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "export-page-getInTouch",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            onSelect: (selectedCountryCode)=>{
                                                const selectedCountry = countries.find((country)=>country.code === selectedCountryCode);
                                                setTouch({
                                                    ...touch,
                                                    countryCode: selectedCountryCode,
                                                    cc: selectedCountry ? selectedCountry.cc : ""
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Toggle */ .Z.Toggle, {
                                                    variant: "secondary",
                                                    id: "dropdown-basic",
                                                    children: [
                                                        touch.countryCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                    countryCode: touch.cc,
                                                                    svg: true
                                                                }),
                                                                " (".concat(touch.countryCode, ")")
                                                            ]
                                                        }),
                                                        !touch.countryCode && "Country Code"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Menu */ .Z.Menu, {
                                                    style: {
                                                        maxHeight: "200px",
                                                        overflowY: "auto"
                                                    },
                                                    children: countries.map((country)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item, {
                                                            eventKey: country.code,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                        countryCode: country.cc,
                                                                        svg: true
                                                                    }),
                                                                    "".concat(country.name, " (").concat(country.code, ")")
                                                                ]
                                                            })
                                                        }, country.code))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                            type: "number",
                                            placeholder: "Mobile Number*",
                                            onChange: (e)=>{
                                                setTouch({
                                                    ...touch,
                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                });
                                            }
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                    type: "number",
                                    placeholder: "Mobile Number*",
                                    onChange: (e)=>{
                                        setTouch({
                                            ...touch,
                                            number: "".concat(touch.countryCode || "").concat(e.target.value)
                                        });
                                    }
                                })
                            }),
                            router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                className: "mb-3",
                                controlId: "formBasicPassword",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                    type: "email",
                                    value: touch.email,
                                    placeholder: "Email",
                                    onChange: (e)=>{
                                        setTouch({
                                            ...touch,
                                            email: e.target.value
                                        });
                                    }
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                className: "mb-3",
                                controlId: "formBasicPassword",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                    type: "number",
                                    value: touch.pincode,
                                    placeholder: "Pincode (Optional)",
                                    onChange: (e)=>{
                                        setTouch({
                                            ...touch,
                                            pincode: e.target.value
                                        });
                                    }
                                })
                            }),
                            touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "error text-danger",
                                children: touch.error
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: "primary",
                                type: "submit",
                                disabled: touch.loading,
                                style: {
                                    width: "100%"
                                },
                                children: touch.loading ? "Submitting" : "Submit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "getintouch_siadebar",
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/get-touch-thumbnail.svg",
                                    alt: "get in touch"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Talk to Expert"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaAngleRight */ .H_v, {})
                        ]
                    })
                ]
            }),
            router.asPath == "/exports-project" || router.asPath == "/download-export-catalogue" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mobile_view_footericon",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "foot-info-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "ttel:+91-9599770470",
                                    "aria-level": "phone",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaPhone */ .I7T, {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "foot-info-col",
                        id: "Whatsapp_button_mobile_footer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://wa.me/919599770470?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaWhatsapp */ .xpo, {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Whatsapp"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mobile_view_footericon",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "foot-info-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "tel:1800 208 1015",
                                    "aria-level": "phone",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaPhone */ .I7T, {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "foot-info-col",
                        id: "Whatsapp_button_mobile_footer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "foot-icon-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaWhatsapp */ .xpo, {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Whatsapp"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                class: "mobile-foot-category-row",
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        class: "foot-info-col",
                        id: "Store_locator_mobile_footer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "https://www.orientbell.com/store-locator",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "18",
                                    height: "17",
                                    viewBox: "0 0 18 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M17.0052 0.981934V2.99216H1.0169V0.981934H17.0052ZM17.987 10.9863H17.0052V16.9703H14.995V10.9863H11.0213V16.9703H1.0169V10.9863H0.0351562V8.9761L1.0169 3.9739H17.0052L17.987 8.9761V10.9863ZM9.01106 14.96V10.9863H3.02712V14.96H9.01106Z",
                                        fill: "#BFBFBF"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Stores"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        class: "foot-info-col",
                        id: "Catalogue_button_mobile_footer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "https://www.orientbell.com/download-catalogue",
                            "aria-label": "category",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "16",
                                    height: "18",
                                    viewBox: "0 0 16 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M0.414062 14.8092C0.414063 15.4723 0.677455 16.1082 1.1463 16.577C1.61514 17.0459 2.25102 17.3092 2.91406 17.3092H12.9141C13.5771 17.3092 14.213 17.0459 14.6818 16.577C15.1507 16.1082 15.4141 15.4723 15.4141 14.8092V6.33258C15.4137 5.66988 15.1502 5.03444 14.6816 4.56591L11.4916 1.37424C11.0227 0.905677 10.3869 0.642499 9.72406 0.642578H2.91406C2.25102 0.642578 1.61514 0.90597 1.1463 1.37481C0.677455 1.84365 0.414063 2.47954 0.414062 3.14258V14.8092ZM8.7474 8.97591C8.7474 8.7549 8.6596 8.54294 8.50332 8.38666C8.34704 8.23038 8.13508 8.14258 7.91406 8.14258C7.69305 8.14258 7.48109 8.23038 7.32481 8.38666C7.16853 8.54294 7.08073 8.7549 7.08073 8.97591V11.9642L6.00323 10.8867C5.84606 10.7349 5.63556 10.651 5.41706 10.6529C5.19856 10.6547 4.98955 10.7424 4.83505 10.8969C4.68054 11.0514 4.5929 11.2604 4.591 11.4789C4.5891 11.6974 4.6731 11.9079 4.8249 12.0651L7.3249 14.5651C7.48117 14.7213 7.69309 14.8091 7.91406 14.8091C8.13503 14.8091 8.34696 14.7213 8.50323 14.5651L11.0032 12.0651C11.155 11.9079 11.239 11.6974 11.2371 11.4789C11.2352 11.2604 11.1476 11.0514 10.9931 10.8969C10.8386 10.7424 10.6296 10.6547 10.4111 10.6529C10.1926 10.651 9.98206 10.7349 9.8249 10.8867L8.7474 11.9642V8.97591Z",
                                        fill: "#BFBFBF"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Catalogue"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "review-Catalouge",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "d-catalog-row",
                        children: router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/download-export-catalogue"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/brouchure.png",
                                    alt: "Image"
                                }),
                                " DOWNLOAD CATALOGUE"
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/download-catalogue"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/brouchure.png",
                                    alt: "Image"
                                }),
                                " DOWNLOAD CATALOGUE"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fromUs-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "ft-fromUs-row flex-class",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "fr-Title",
                                children: "Request a Callback"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "us-form-col",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                    className: "flex-class",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                value: callBackDto.name,
                                                onChange: (e)=>{
                                                    onValueChange(e, "name");
                                                },
                                                placeholder: "Name",
                                                className: "input-bx"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                (router.asPath.includes("exports-project") || router.asPath.includes("download-export-catalogue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    onSelect: (selectedCountryCode)=>{
                                                        const selectedCountry = countries.find((country)=>country.code === selectedCountryCode);
                                                        setCallBackDto({
                                                            ...callBackDto,
                                                            countryCode: selectedCountryCode,
                                                            cc: selectedCountry ? selectedCountry.cc : ""
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Toggle */ .Z.Toggle, {
                                                            variant: "secondary",
                                                            id: "dropdown-basic",
                                                            children: callBackDto.countryCode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                        countryCode: callBackDto.cc,
                                                                        svg: true
                                                                    }),
                                                                    " (".concat(callBackDto.countryCode, ")")
                                                                ]
                                                            }) : !touch.callBackDto && "Country"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Menu */ .Z.Menu, {
                                                            style: {
                                                                maxHeight: "200px",
                                                                overflowY: "auto"
                                                            },
                                                            children: countries.map((country)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item, {
                                                                    eventKey: country.code,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                                countryCode: country.cc,
                                                                                svg: true
                                                                            }),
                                                                            "".concat(country.name, " (").concat(country.code, ")")
                                                                        ]
                                                                    })
                                                                }, country.code))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "number",
                                                    value: callBackDto.number,
                                                    onChange: (e)=>{
                                                        onValueChange(e, "number");
                                                    },
                                                    placeholder: "Mobile Number",
                                                    className: "input-bx"
                                                })
                                            ]
                                        }),
                                        router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "email",
                                                value: callBackDto.email,
                                                onChange: (e)=>{
                                                    onValueChange(e, "email");
                                                },
                                                placeholder: "Email",
                                                className: "input-bx"
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "number",
                                                value: callBackDto.pincode,
                                                onChange: (e)=>{
                                                    onValueChange(e, "pincode");
                                                },
                                                placeholder: "Pincode (Optional)",
                                                className: "input-bx"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "form-group button",
                                            children: callBackDto.loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                className: "ft-submit-btn",
                                                children: "Submitting"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                className: "ft-submit-btn",
                                                onClick: ()=>onSubmitClick(),
                                                children: "Submit"
                                            })
                                        }),
                                        callBackDto.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "error text-danger",
                                            children: callBackDto.error
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "footer-main",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "footer-top flex-class",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[0] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(0),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/floor-tiles",
                                                                children: "Floor Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/wall-tiles",
                                                                children: "Wall Tiles"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    class: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: isClassToggled[16] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(16),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                children: "Locations"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/delhi",
                                                                        children: "Delhi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/mumbai",
                                                                        children: "Mumbai"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/bangalore",
                                                                        children: "Bengaluru"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/darjeeling",
                                                                        children: "Darjeeling"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/alipurduar",
                                                                        children: "Alipurduar"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/jangipur",
                                                                        children: "Jangipur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/raiganj",
                                                                        children: "Raiganj"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/hyderabad",
                                                                        children: "Hyderabad"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/chennai",
                                                                        children: "Chennai"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/kolkata",
                                                                        children: "Kolkata"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/lucknow",
                                                                        children: "Lucknow"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/pune",
                                                                        children: "Pune"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/bhopal",
                                                                        children: "Bhopal"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/jabalpur",
                                                                        children: "Jabalpur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/indore",
                                                                        children: "Indore"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/nagpur",
                                                                        children: "Nagpur"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/coimbatore",
                                                                        children: "Coimbatore"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/patna",
                                                                        children: "Patna"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/ernakulam",
                                                                        children: "Ernakulam"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/narnaul",
                                                                        children: "Narnaul"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/mahendragarh",
                                                                        children: "Mahendragarh"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/sohna",
                                                                        children: "Sohna"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/nuh",
                                                                        children: "Nuh"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/noida",
                                                                        children: "Noida"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/gurugram",
                                                                        children: "Gurugram"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/pataudi",
                                                                        children: "Pataudi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/bhiwadi",
                                                                        children: "Bhiwadi"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/manesar",
                                                                        children: "Manesar"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/dharuhera",
                                                                        children: "Dharuhera"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: " https://www.orientbell.com/tiles/farukhnagar",
                                                                        children: "Farukhnagar"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[1] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(1),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Area"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bathroom-tiles",
                                                                children: "Bathroom Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles",
                                                                children: "Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/parking-tiles",
                                                                children: "Parking Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/elevation-tiles",
                                                                children: "Elevation Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bedroom-tiles",
                                                                children: "Bedroom Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/outdoor-tiles",
                                                                children: "Outdoor Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/terrace-tiles",
                                                                children: "Terrace Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/living-room-tiles",
                                                                children: "Living Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/balcony-tiles",
                                                                children: "Balcony Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/swimming-pool-tiles",
                                                                children: "Swimming Pool Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/porch-tiles",
                                                                children: "Porch Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/office-tiles",
                                                                children: "Office Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pathway-tiles",
                                                                children: "Pathway Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dining-room-tiles",
                                                                children: "Dining Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/commercial-tiles",
                                                                children: "Commercial Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bar-tiles",
                                                                children: "Bar Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/restaurant-tiles",
                                                                children: "Restaurant Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/hospital-tiles",
                                                                children: "Hospital Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/accent-tiles",
                                                                children: "Accent Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/automotive-tiles",
                                                                children: "Automotive Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/school-tiles",
                                                                children: "School Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/high-traffic-tiles",
                                                                children: "High Traffic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/step-stairs-tiles",
                                                                children: "Stairs Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pooja-room-tiles",
                                                                children: "Pooja Room Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/large-tiles",
                                                                children: "Large Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/slab-tiles",
                                                                children: "Slab Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/tile-collection/gvt-anti-skid-inspire-safegrip",
                                                                children: "GVT Anti Skid"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/white-kitchen-tiles",
                                                                children: "White Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/blue-kitchen-tiles",
                                                                children: "Blue Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/green-kitchen-tiles",
                                                                children: "Green Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/kitchen-tiles/black-kitchen-tiles",
                                                                children: "Black Kitchen Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dolphin-tiles",
                                                                children: "Dolphin Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[2] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(2),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Design"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/3d-tiles",
                                                                children: "3d Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/wooden-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Wooden Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/marble-tiles",
                                                                children: "Marble Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/texture-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Texture Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/mosaic-tiles",
                                                                children: "Mosaic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/granite-tiles",
                                                                children: "Granite Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/stone-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Stone Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pattern-tiles",
                                                                children: "Pattern Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/cement-tiles",
                                                                children: "Cement Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/flower-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Flower Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/travertine-tiles",
                                                                children: "Travertine Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/slate-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Slate Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/statuario-tiles",
                                                                children: "Statuario Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/plain-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Plain Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/onyx-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Onyx Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/metallic-tiles",
                                                                children: "Metallic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/bottochino-tiles",
                                                                children: "Bottochino Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/book-match-tiles",
                                                                children: "Book Match Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/geometric-tiles",
                                                                children: "Geometric Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/carrara-tiles",
                                                                children: "Carrara Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/abstract-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Abstract Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/monochrome-tiles",
                                                                children: "Monochrome Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/stylized-tiles",
                                                                children: "Stylized Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/brick-tiles",
                                                                children: "Brick Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/hexagonal-tiles",
                                                                children: "Hexagonal Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/limestone-tiles",
                                                                children: "Limestone Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/wooden-plank-tiles",
                                                                children: "Plank Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[3] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(3),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Type"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles",
                                                                children: "Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/ceramic-tiles",
                                                                children: "Ceramic Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/porcelain-tiles",
                                                                children: "Porcelain Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/designer-tiles",
                                                                children: "Designer Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/anti-skid-tiles",
                                                                children: "Anti Skid Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/digital-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Digital Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/double-charge-tiles",
                                                                children: "Double Charge Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/gvt-tiles",
                                                                children: "GVT Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/cool-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Cool Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/highlighter-tiles",
                                                                children: "Highlighter Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/pgvt-tiles ",
                                                                children: [
                                                                    "PGVT Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/full-body-vitrified-tiles",
                                                                children: "Full Body Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/polished-vitrified-tiles",
                                                                children: [
                                                                    "Polished Vitrified Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/germ-free-tiles",
                                                                children: "Germ Free Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/dgvt-tiles",
                                                                children: "DGVT Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/forever-tiles",
                                                                children: "Scratch Free Tile(Forever Tile)"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/vitrified-tiles/digital-glazed-vitrified-tiles",
                                                                children: "Double Glazed Vitrified Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/stain-resistant-tiles",
                                                                children: "Stain Resistant Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/nano-tiles",
                                                                children: "Nano Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/non-digital-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Non Digital Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/anti-static-tiles",
                                                                children: "Anti Static Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/carving-tiles",
                                                                children: "Carving Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/gvt-endless-tiles",
                                                                children: "GVT Endless Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[4] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(4),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Colour"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/terracotta-tiles",
                                                                children: "Terracotta Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/white-tiles",
                                                                children: [
                                                                    " ",
                                                                    "White Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/black-tiles",
                                                                children: "Black Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/grey-tiles",
                                                                children: "Grey Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/chequered-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Chequered Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/blue-tiles",
                                                                children: "Blue Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/red-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Red Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/green-tiles",
                                                                children: "Green Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/beige-tiles",
                                                                children: "Beige Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/ivory-tiles",
                                                                children: "Ivory Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/yellow-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Yellow Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/cream-tiles",
                                                                children: "Cream Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/pink-tiles",
                                                                children: "Pink Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/light-tiles",
                                                                children: "Light Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/dark-tiles",
                                                                children: "Dark Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/purple-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Purple Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/multi-colour-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Multi Colour Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/wenge-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Wenge Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/brown-tiles",
                                                                children: "Brown Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/sandune-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Sandune Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/black-and-white-tiles",
                                                                children: [
                                                                    " ",
                                                                    "Black and White Tiles"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[5] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(5),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Size"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/2x2-tiles",
                                                                children: "600X600 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/2x4-tiles",
                                                                children: "600X1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/1x1-tiles",
                                                                children: "300X300 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/300x600-tiles",
                                                                children: "300x600 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/395x395-tiles",
                                                                children: "395x395 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/300x450-tiles",
                                                                children: "300x450 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/200x1200-tiles",
                                                                children: "200x1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/800x800-tiles",
                                                                children: "800x800 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/inspire-xl-1200x1800",
                                                                children: "800x1200 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/800x1600-tiles",
                                                                children: [
                                                                    " ",
                                                                    "800x1600 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/granalt-tiles",
                                                                children: [
                                                                    " ",
                                                                    "800x2400 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/145x600-tiles",
                                                                children: [
                                                                    " ",
                                                                    "145x600 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/195x1200-tiles",
                                                                children: [
                                                                    " ",
                                                                    "195x1200 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/295x295-tiles",
                                                                children: "295x295 mm Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/200x300-tiles",
                                                                children: [
                                                                    " ",
                                                                    "200x300 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/250x375-tiles",
                                                                children: [
                                                                    " ",
                                                                    "250x375 mm Tiles"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: "https://www.orientbell.com/tiles/400x400-tiles",
                                                                children: [
                                                                    " ",
                                                                    "400x400 mm Tiles",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/1000x1000-tiles",
                                                                children: "1000x1000 mm Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[6] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(6),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Tiles by Finish"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/matte-finish-tiles",
                                                                children: "Matte Finish Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/glossy-tiles",
                                                                children: "Glossy Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/sugar-finish-tiles",
                                                                children: "Sugar Finish Tiles"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/super-glossy-tiles",
                                                                children: "Super Glossy Tiles"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: isClassToggled[7] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(7),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                children: "Tiles Collection"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/sparkle",
                                                                        children: "Sparkle Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/estilo",
                                                                        children: "Estilo Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/ft-autumn2020",
                                                                        children: "FT Autumn 2020 Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/sahara",
                                                                        children: "Sahara Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/rhino-series-pavers-tiles",
                                                                        children: "Rhino Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/duazzle",
                                                                        children: "Duazzle Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/inspire",
                                                                        children: "Inspire Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/hd-p-elevation",
                                                                        children: "HD-P Elevation Tiles Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/tiles/tile-collection/inspire-planks",
                                                                        children: "Inspire Planks Tiles Collection"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "foot-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: isClassToggled[15] ? "f-heading active-link" : "f-heading",
                                                            onClick: ()=>toggleClass(15),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                children: "Tools"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/tile-calculator"),
                                                                        children: "Tile Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/area-conversion-calculator"),
                                                                        children: "Area Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/paint-cost-calculator"),
                                                                        children: "Paint Calculator"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/construction-cost-calculator"),
                                                                        children: "Cost Estimator"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "footer-top ft-bottom flex-class",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[8] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(8),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/about-us",
                                                                children: "Who are we?"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/investor",
                                                                children: "Investors Relation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/career",
                                                                children: "Careers"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/press-release",
                                                                children: "Media"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/sustainability",
                                                                children: "Sustainability"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[9] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(9),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Useful links"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    className: "smooth-check 12",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/contact-us",
                                                                children: "Contact us"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/faq",
                                                                children: "FAQ"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/store-locator",
                                                                children: "Store Locator"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/site-map",
                                                                children: "Sitemap"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/signature-company-showrooms",
                                                                children: "Signature Company Showrooms"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://stores.orientbell.com",
                                                                children: "Orientbell Tiles Boutique Locator"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[10] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(10),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Solutions for"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tile-selector",
                                                                children: "Home Owners"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tiles/school-tiles",
                                                                children: "Education"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/trulook",
                                                                children: "Home Designing Solution"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/tile-buying",
                                                                children: "Tile Buying Guide"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/blog",
                                                                children: "Inspirations for you"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/blog/web-story/",
                                                                children: "Web Stories"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/design-ideas/",
                                                                children: "Design Ideas"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col foot-connect",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[12] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(12),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Connect with us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    className: "Social-Icons flex-class",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.facebook.com/OrientBellTiles/",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/facebook.jpg",
                                                                    alt: "Facebook",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.linkedin.com/company/orientbellltd",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/linkedIn.jpg",
                                                                    alt: "LinkedIn",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://twitter.com/OrientbellTiles",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    style: {
                                                                        background: "#e6e6e6"
                                                                    },
                                                                    width: "20px",
                                                                    src: "https://www.edigitalagency.com.au/wp-content/uploads/new-Twitter-logo-x-black-png.png",
                                                                    alt: "Twitter",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://wa.me/918750733333?text=",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/whatsapp.jpg",
                                                                    alt: "WhatsApp",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.instagram.com/orientbell/?hl=en",
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://88nbxydt.cdn.imgeng.in/media/wysiwyg/insta-icon.png",
                                                                    alt: "instagram",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "select-lang",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            htmlFor: "P9LngDdl",
                                                            style: {
                                                                color: "#fffff1"
                                                            },
                                                            children: "Change Language"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                            id: "P9LngDdl",
                                                            className: "mobilelanguga",
                                                            onChange: (e)=>{
                                                                if (e.target.value) {
                                                                    router.push(e.target.value);
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select "
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "https://orientbell.com/".concat(router.asPath),
                                                                    children: "English"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "https://hindi.orientbell.com/".concat(router.asPath),
                                                                    children: "हिंदी"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "https://tamil.orientbell.com/".concat(router.asPath),
                                                                    children: "தமிழ்"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col cpaddress",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[13] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(13),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Corporate Office"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        "Iris House, 16 Business Centre,Nangal Raya,",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        "DDA Complex,New Delhi – 110046 (India)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "telno",
                                                    children: [
                                                        "Tel: ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "tel:911147119100",
                                                            children: "+91-11-47119100"
                                                        }),
                                                        ", -",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "tel:911147119200",
                                                            children: "47119200"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "telno",
                                                    children: [
                                                        "Email:",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "mailto:customercare@orientbell.com",
                                                            children: "customercare@orientbell.com"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "foot-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: isClassToggled[14] ? "f-heading active-link" : "f-heading",
                                                    onClick: ()=>toggleClass(14),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "Policies"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/privacy-policy",
                                                                children: "Privacy Policy"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/shipping-policy",
                                                                children: "Shipping Policy"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://www.orientbell.com/return-and-refund-policy",
                                                                children: "Returns & Refund Policy"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "maplocate",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        loading: "lazy",
                                                        src: "/footer-paymet2_1_1.webp",
                                                        alt: "Image"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "footer-badge-row",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                        className: "flex-class",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/media/pdf/GRIHA.pdf",
                                                                        download: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            loading: "lazy",
                                                                            src: "/GRIHA.png",
                                                                            alt: "Image"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "https://www.orientbell.com/quality-certificates",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/CE-11.png",
                                                                        alt: "Image"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "https://www.orientbell.com/quality-certificates",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        loading: "lazy",
                                                                        src: "/IS.png",
                                                                        alt: "Image"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "https://www.orientbell.com/media/pdf/Orient_Bell_Ltd.pdf",
                                                                        download: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            loading: "lazy",
                                                                            src: "/IGBC.png",
                                                                            alt: "Image"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    tarrekImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        class: "get-in-touchpopup",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                // src="/Get in Touch Design for website 212x340 Pix.webp"
                                src: "/tareek_get_in_touch.avif",
                                alt: "tareek image",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setGetInTouch(true);
                                    settarrekImage(false);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                class: "icon-close-black-icon",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    settarrekImage(false);
                                    localStorage.setItem("TarikClosed", true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/close_round_icon.svg",
                                    alt: "close icon"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "copy-right",
                children: "Copyright \xa9 2025 OrientBell, All rights reserved."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                show: getInTouch,
                className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
                onHide: ()=>{
                    setTimePopup(false);
                    setGetInTouch(false);
                    localStorage.setItem("leadSkiped", true);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Title */ .Z.Title, {
                                children: TimePopup ? "Get in touch with our tile's expert" : "Get In Touch"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ask-question-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "expert-fig-bx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/new-tareek.jpg"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Ask Tile Expert"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Let Experts Help You In Buying Process"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                submitGetInTouch(TimePopup ? router.asPath.includes("/exports-project") ? "Get In Touch 15_sec_Pop-up export" : "Get In Touch 15_sec_Pop-up" : router.asPath.includes("/exports-project") ? "Get In Touch Tariq export" : "Get In Touch Tariq");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    name: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                            children: "Mobile"
                                                        }),
                                                        router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "export-page-getInTouchTariq",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                    onSelect: (selectedCountryCode)=>{
                                                                        const selectedCountry = countries.find((country)=>country.code === selectedCountryCode);
                                                                        setTouch({
                                                                            ...touch,
                                                                            countryCode: selectedCountryCode,
                                                                            cc: selectedCountry ? selectedCountry.cc : ""
                                                                        });
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Toggle */ .Z.Toggle, {
                                                                            variant: "secondary",
                                                                            id: "dropdown-basic",
                                                                            children: [
                                                                                touch.countryCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                                            countryCode: touch.cc,
                                                                                            svg: true
                                                                                        }),
                                                                                        " (".concat(touch.countryCode, ")")
                                                                                    ]
                                                                                }),
                                                                                !touch.countryCode && "Country Code"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Menu */ .Z.Menu, {
                                                                            style: {
                                                                                maxHeight: "200px",
                                                                                overflowY: "auto"
                                                                            },
                                                                            children: countries.map((country)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item, {
                                                                                    eventKey: country.code,
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                                                countryCode: country.cc,
                                                                                                svg: true
                                                                                            }),
                                                                                            "".concat(country.name, " (").concat(country.code, ")")
                                                                                        ]
                                                                                    })
                                                                                }, country.code))
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                    type: "number",
                                                                    onChange: (e)=>{
                                                                        setTouch({
                                                                            ...touch,
                                                                            number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                        });
                                                                    }
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                router.asPath.includes("/exports-project") || router.asPath.includes("/download-export-catalogue") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                        type: "email",
                                                        value: touch.email,
                                                        placeholder: "Email",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                email: e.target.value
                                                            });
                                                        }
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                            children: "Pincode (Optional)"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            value: touch.pincode,
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    pincode: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error text-danger",
                                                    children: touch.error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "recording",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        onClick: recording ? stopRecording : startRecording,
                                                        type: "button",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: " "
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: " "
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: " "
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: " "
                                                            }),
                                                            recording ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/recording.gif",
                                                                        alt: "mic-image"
                                                                    }),
                                                                    " Stop Recording"
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/nic-ing.png",
                                                                        alt: "mic-image"
                                                                    }),
                                                                    " Record your Audio"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                audioBlob && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("audio", {
                                                        controls: true,
                                                        src: URL.createObjectURL(audioBlob)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    type: "submit",
                                                    disabled: touch.loading,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: touch.loading ? "Submitting" : "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            router.asPath === "/" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                show: LocationPopop,
                className: "pincode-popup-bx expert_assistance_modal",
                onHide: ()=>{
                    js_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"].set */ .Z.set("skipLocation", true, {
                        expires: 7,
                        secure: true,
                        sameSite: "Strict"
                    });
                    setleadpopop();
                    setLocationPopop(false);
                    popoptarek();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "main-location-popup",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Dialog */ .Z.Dialog, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                closeButton: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    class: "location-pop-section",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            class: "location-icon-bx",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/location-icon.png",
                                                alt: "location icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "location-text-bx",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Title */ .Z.Title, {
                                                    children: "Allow Your Location to get best prices in your area"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_address__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    setLocationPopop: setLocationPopop,
                                    setleadpopop: setleadpopop,
                                    settarrekImage: settarrekImage
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

}]);